/**
 * Tag
 */
export interface Tag {
  oid: number
  name: string
  count?: number
  favourite?: boolean
  external?: boolean
  sysCtime?: string
  sysMtime?: string
  children?: TagChildren[]
  totalCount?: TagCount
}

export interface TagChildren {
  oid: number
  name: string
  count: number
  parentTagOid: number
  tagOid: number
  sysCtime?: string
  sysMtime?: string
}

export interface TagCount {
  oid: number
  count: number
}

const oid: keyof Tag = 'oid'

export function isNew(tag: object) {
  return !(oid in tag)
}
